// React
import React, { Fragment, useState, useRef } from 'react'
import { createPortal } from 'react-dom'
import PropTypes from 'prop-types'

import BImageMagnify from 'store/modules/product/blocks/ImageMagnify'

import { interpolateNumber } from 'd3-interpolate'

const ImageRenderer = (props) => {
  const originalRef = useRef(null)

  const [originalDimensions, setOriginalDimensions] = useState(null)

  const handleOriginalLoad = ({ target: img }) => {
    setOriginalDimensions({ height: img.offsetHeight, width: img.offsetWidth })
  }

  const calculatePosition = (x, y) => {
    const offset = 50 * props.scale

    if (!originalRef || !originalRef.current) return '0 0'

    const box = originalRef.current.getBoundingClientRect()
    const { width, height } = box

    const lo = (x / width) * 100
    const wo = (y / height) * 100

    const rx = `calc(${lo}% + ${interpolateNumber(offset, -offset)(lo / 100)}px)`
    const ry = `calc(${wo}% + ${interpolateNumber(offset, -offset)(wo / 100)}px)`

    return `${rx} ${ry}`
  }

  const imageIsVertical = originalDimensions && originalDimensions.height > (props.size || props.height)

  return (
    <Fragment>
      <BImageMagnify.ImageContainer>
        <BImageMagnify.Image
          src={props.originalImage}
          alt={props.imageAlt}
          width={imageIsVertical ? 'auto' : props.size - 6 || props.width - 6}
          height={imageIsVertical ? props.size - 6 || props.height - 6 : 'auto'}
          ref={originalRef}
          onLoad={handleOriginalLoad}
        />
      </BImageMagnify.ImageContainer>
      {originalRef?.current &&
        createPortal(
          <BImageMagnify.PortalContainer width={props.zoomedSize || props.zoomedWidth || props.elementDimensions.width} height={props.zoomedSize || props.zoomedHeight || props.elementDimensions.height}>
            <BImageMagnify.Portal
              image={props.zoomedImage || props.originalImage}
              scale={props.scale || 1.2}
              style={{
                backgroundPosition: calculatePosition(props.activePosition.x, props.activePosition.y)
              }}
            />
          </BImageMagnify.PortalContainer>,
          props.portalTarget || document.body
        )}
    </Fragment>
  )
}

ImageRenderer.propTypes = {
  originalImage: PropTypes.string.isRequired,
  zoomedImage: PropTypes.string,
  imageAlt: PropTypes.string,
  size: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
  zoomedSize: PropTypes.number,
  zoomedWidth: PropTypes.number,
  zoomedHeight: PropTypes.number,
  elementDimensions: PropTypes.object,
  portalTarget: PropTypes.any,
  activePosition: PropTypes.object,
  scale: PropTypes.number
}

export default ImageRenderer
